import getInstanceAxios from './RequestGlobalConfig';

export default getInstanceAxios(process.env.REACT_APP_TIMELINE_SOCKET);
